// Component gallery (dev and staging): the guard only; the page is in gallery.lazy.tsx, outside the
// initial chunk (spec 024).
import { createFileRoute, notFound } from '@tanstack/react-router'

import { galleryEnabled } from '../lib/env.js'

export const Route = createFileRoute('/gallery')({
  beforeLoad: () => {
    if (!galleryEnabled()) {
      throw notFound()
    }
  },
})
